import React from "react";
import { LoginFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons } from "components";

const LoginForm = ({ onSubmit }) => {
  const schema = yup.object().shape({
    username: yup.string().required("*Required"),
    password: yup.string().required("*Required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const { t } = useTranslation(["common", "form"]);

  return (
    <LoginFormStyled>
      <div className="login_header">{t("Log in", { ns: "common" })}</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                placeholder={t("Enter your Email", { ns: "form" })}
                errors={errors.username?.message}
              />
            )}
            name="username"
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Password
                {...field}
                placeholder={t("Enter your Password", { ns: "form" })}
                errors={errors.password?.message}
              />
            )}
            name="password"
          />
        </div>
        <div className="btn_wrap">
          <Buttons.BgStandard
            type="submit"
            label={t("Continue", { ns: "common" })}
          />
        </div>
      </form>
    </LoginFormStyled>
  );
};

LoginForm.propTypes = {};
export default LoginForm;
